<template>
    <div class="exam">
        <!-- banner区域 -->
        <section class="banner">
            <el-button size="default"
                       type="primary"
                       @click.stop="handleFreeBtnClick"
                       style="min-width: 140px; min-height: 46px">免费试用
            </el-button>
            <div class="banner-card">
                <div class="banner-card-item">
                    <img src="@/assets/img/homes/exam/exam-card-import.png" alt="import"/>
                    <h3>试卷灵活录入</h3>
                    <div>模板导入 | 智能录入</div>
                    <div>单题编辑</div>
                </div>
                <div class="banner-card-item">
                    <img src="@/assets/img/homes/exam/exam-card-paper.png" alt="paper"/>
                    <h3>组卷方式多样</h3>
                    <div>自动抽题 | 系统抽题</div>
                    <div>人工抽题 | 随机组卷</div>
                </div>
                <div class="banner-card-item">
                    <img src="@/assets/img/homes/exam/exam-card-setting.png" alt="setting"/>
                    <h3>多项考场设置</h3>
                    <div>参考次数 | 考场密码</div>
                    <div>试题乱序 | 指定人员考试</div>
                </div>
                <div class="banner-card-item">
                    <img src="@/assets/img/homes/exam/exam-card-analyse.png" alt="analyse"/>
                    <h3>全面考场分析</h3>
                    <div>分数段统计 | 成绩排名统计</div>
                    <div>答题情况统计 | 分题统计</div>
                </div>
            </div>
        </section>
        <!-- 内容区域 -->
        <section class="content">
            <el-row type="flex" justify="center">
                <el-button type="primary" style="min-width: 140px; min-height: 46px" size="default"  @click.stop="handleFreeBtnClick">免费试用</el-button>
            </el-row>
            <!-- 专属试题资源库 -->
            <div class="content-common">
                <div>
                    <div class="order-index">01</div>
                    <h3 class="first-title">专属试题资源库管理</h3>
                    <h4 class="second-title order-circle">试题管理 | <span
                        class="desc">支持单题录入、智能粘贴复制录入，也可以模版（word）导入。</span></h4>
                    <h4 class="second-title order-circle">试卷管理 | <span
                        class="desc">支持自动抽题、系统抽题、随机组卷、人工增题，可以自由灵活组卷。</span></h4>
                    <el-button type="primary" style="min-width: 140px; min-height: 46px" size="default"  @click.stop="handleFreeBtnClick">免费试用</el-button>
                </div>
                <img src="@/assets/img/homes/exam/exam-content-paper.png" alt="content-paper"/>
            </div>
            <!-- 全流程在线服务考试 -->
            <div class="content-common">
                <img src="@/assets/img/homes/exam/exam-content-exam.png" alt="content-paper"/>
                <div>
                    <div class="order-index">02</div>
                    <h3 class="first-title">全流程在线考试服务</h3>
                    <h4 class="second-title order-circle">防作弊 | <span
                        class="desc">全屏防作弊、AB卷、试题打乱顺序、选项打乱顺序、异常标识、强制收卷。</span></h4>
                    <h4 class="second-title order-circle">智能阅卷 | <span
                        class="desc">客观题系统将自动批量阅卷、自动评分。</span></h4>
                    <h4 class="second-title order-circle">考试成绩｜<span
                        class="desc">系统从分数、排名、机构部门、答题情况等提供多维度的考试过程和结果的统计分析。</span></h4>
                    <el-button type="primary" style="min-width: 140px; min-height: 46px" size="default"  @click.stop="handleFreeBtnClick">免费试用</el-button>
                </div>
            </div>
            <!-- 机构个性化定制服务 -->
            <div class="content-common">
                <div>
                    <div class="order-index">03</div>
                    <h3 class="first-title">机构个性化定制服务</h3>
                    <h4 class="second-title order-circle">个性化展示｜ <span
                        class="desc">机构名称、平台名称、Logo等可以根据机构需求个性化展示。</span></h4>
                    <h4 class="second-title order-circle">功能定制 | <span
                        class="desc">学分记录、会议签到…等通用功能，平台可免费开发。</span></h4>
                    <el-button type="primary" style="min-width: 140px; min-height: 46px" size="default"  @click.stop="handleFreeBtnClick">免费试用</el-button>
                </div>
                <img src="@/assets/img/homes/exam/exam-content-organization.png" alt="content-paper"/>
            </div>
        </section>
        <!-- 考试服务 -->
        <section class="online-exam-service">
            <img src="@/assets/img/homes/exam/exam-online-exam-title.png" alt="exam-online-exam-title">
            <div class="card-list">
                <div class="card">
                    <img src="@/assets/img/homes/exam/exam-online-exam-train.png"
                         class="card-img"
                         alt="online-exam-train"/>
                    <h3 class="title">入管培训考核</h3>
                    <div class="desc">
                        培训成果验收，随堂测验，课后练习，不受场地限制。
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/exam/exam-online-exam-appraisal.png"
                         class="card-img"
                         alt="online-exam-appraisal"/>
                    <h3 class="title">高校大学测评</h3>
                    <div class="desc">
                        高校学期考试，课后知识巩固练习，随堂作业，考前刷题练习。
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/exam/exam-online-exam-practice.png"
                         class="card-img"
                         alt="online-exam-practice"/>
                    <h3 class="title">课堂练习测评</h3>
                    <div class="desc">
                        灵活的随机出题策略，支持多题目批量智能导入，学生可查看错题解析。
                    </div>
                </div>
                <div class="card">
                    <img src="@/assets/img/homes/exam/exam-online-exam-competition.png"
                         class="card-img"
                         alt="online-exam-competition"/>
                    <h3 class="title">专项知识竞赛</h3>
                    <div class="desc">
                        各种答题竞赛活动，知识推广普及，支持千人同时答题，成绩分析精细全面。
                    </div>

                </div>
                <div class="card">
                    <img src="@/assets/img/homes/exam/exam-online-exam-assess.png"
                         class="card-img"
                         alt="online-exam-assess"/>
                    <h3 class="title">内部晋升考核</h3>
                    <div class="desc">
                        支持企业数字化、无纸化考核评鉴，全面支持通用能力、岗位胜任力、团队合作、等全方位人才测评。
                    </div>
                </div>
            </div>
            <el-row type="flex" justify="center">
                <el-button type="primary" style="min-width: 140px; min-height: 46px"  @click.stop="handleFreeBtnClick">免费试用</el-button>
            </el-row>
        </section>
        <!-- 典型用户 -->
        <section class="typical-user">
            <img src="@/assets/img/homes/exam/exam-typical-user.png" alt="exam-typical-user"/>
            <div class="links">
                <div>
                    <img src="@/assets/img/homes/exam/jiangxiligong.png" alt="jiangxiligong" width="100%">
                </div>
                <div>
                    <img src="@/assets/img/homes/exam/huizhoujingji.png" alt="huizhoujingji" width="100%">
                </div>
                <div>
                    <img src="@/assets/img/homes/exam/guilin.png" alt="guilin" width="100%">
                </div>
                <div>
                    <img src="@/assets/img/homes/exam/linqikeji.png" alt="linqikeji" width="100%">
                </div>
                <div>
                    <img src="@/assets/img/homes/exam/yunnanjingji.png" alt="yunnanjingji" width="100%">
                </div>
                <div>
                    <img src="@/assets/img/homes/exam/dongwantushuguan.png" alt="dongwantushuguan" width="100%">
                </div>
            </div>
        </section>
        <Dialog ref="dialog"/>
    </div>
</template>

<script>
import Dialog from "./cpns/Dialog"
export default {
    name: "HomeExam",
    components: {
        Dialog
    },
    methods: {
        handleFreeBtnClick () {
            this.$refs.dialog.open()
        },
    }

}
</script>

<style scoped lang="less">
@import "../index";
.exam {
    background-color: #fff;
    width: 100%;
    box-sizing: border-box;
}
.banner {
    box-sizing: border-box;
    width: 100%;
    background-image: url("~@/assets/img/homes/exam/exam-banner.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: left top;
    height: 900px;
    padding: 20% @base-padding 0;
    position: relative;

    &-card {
        background-color: rgba(255, 255, 255, .5);
        display: flex;
        text-align: center;
        box-sizing: border-box;
        padding: 50px 0;
        position: absolute;
        bottom: 0;
        left: 8%;
        right: 8%;
        border-radius: 26px 26px 0 0;
        backdrop-filter: blur(6px);

        &-item {
            flex: 1;
            text-align: center;

            & h3 {
                margin: 24px 0;
                font-size: 24px;
            }

            & div {
                font-size: 17px;
                line-height: 26px;
            }
        }
    }
}

.content {
    padding: 61px 0;
    box-sizing: border-box;
    width: @type-area-width;
    margin: 0 auto;
    .order-index {
        color: #256CF4;
        font-size: 38px;
        font-weight: 600;
    }

    .order-circle::before {
        content: "";
        display: inline-block;
        vertical-align: middle;
        position: relative;
        top: -2px;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        border: 2px solid #256CF4;
        margin-right: 8px;
    }
    .content-common {
        box-sizing: border-box;
        margin-top: 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & .first-title {
            font-size: 24px;
            margin: 26px 0;
        }

        & .second-title {
            font-size: 17px;
            margin-bottom: 26px;

            & .desc {
                font-weight: normal;
                color: #72777F;
                font-size: 15px;
            }
        }

    }
}
.online-exam-service {
    box-sizing: border-box;
    width: 100%;
    background-image: url("~@/assets/img/homes/exam/exam-online-exam-service.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: left top;
    height: 680px;
    padding: 3% @base-padding 0;
    position: relative;
    .card-list {
        display: flex;
        box-sizing: border-box;
        margin: 4% 0;
        .card {
            flex: 1;
            box-sizing: border-box;
            padding: 40px;
            background: rgba(255,255,255,.6);
            border: 1px solid;
            border-image: linear-gradient(116deg, rgba(229, 232, 236, 0.84), rgba(255, 255, 255, 0.84)) 1 1;
            backdrop-filter: blur(25px);
            .title {
                margin: 30px 0;
                padding: 0;
                font-size: 20px;
            }
            .desc {
                font-size: 15px;
            }
        }
    }

}
.typical-user {
    width: @type-area-width;
    margin: 50px auto 0;
    .links {
        margin-top: 50px;
        display: grid;
        // 间隙
        grid-gap: 10px;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: auto;
    }
}
</style>
